export function watcherScreenSize() {
  return {
    data: function () {
      return {
        _width: 0,
        _height: 0,
      };
    },
    computed: {
      $xl() {
        return this.$data._width <= 599.99;
      },
      $sm() {
        return this.$data._width >= 600 && this.$data._width <= 1023.99;
      },
      $md() {
        return this.$data._width >= 1024 && this.$data._width <= 1439.99;
      },
      $lg() {
        return this.$data._width >= 1440 && this.$data._width <= 1919.99;
      },
      $xl() {
        return this.$data._width >= 1920;
      },
      $isPortrait() {
        return this.$data._height > this.$data._width;
      },
    },
    methods: {
      updateSize() {
        this.$data._width =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;

        this.$data._height =
          window.innerHeight ||
          document.documentElement.clientHeight ||
          document.body.clientHeight;
      },
      $isOneOfTypeSize(keys = []) {
        return keys.some((key) => {
          if (typeof this[`$${key}`] !== "boolean") return false;

          return this[`$${key}`];
        });
      },
    },
    mounted() {
      this.updateSize();
      window.addEventListener("resize", this.updateSize);
    },
    destroyed() {
      this.updateSize();
      window.removeEventListener("resize", this.updateSize);
    },
  };
}
